<template>
    <v-form @submit.prevent="addRequest">
        <v-container>
            <v-row class="contentRow">
                <v-col>
                    <h1 class="mb-2">Chain ID: </h1>
                    <p class="mb-10 text-center">The list below shows the Orixe Tracking Chain</p>
                </v-col>
            </v-row>
            <v-row class="contentRow" align="center">
                <v-col>
                    <v-timeline
                            dense
                            clipped
                    >
                    <v-timeline-item
                            v-for="chain in data"
                            :key="chain.ID"
                            :icon="'fas fa-'+ chain.Status.icon"
                            :color="chain.Status.color"
                            fill-dot
                    >
                        <template v-slot:icon>
                            <v-avatar >
                               <v-icon small color="white">fas fa-{{chain.Status.icon}}</v-icon>
                            </v-avatar>
                        </template>
                        <v-card  :style="{ borderColor: chain.Status.color,borderStyle:'solid'}" elevation="0">
                            <v-card-title >
                                <v-row>
                                    <v-col cols="10">
                                        Transaction #{{chain.ID}}
                                    </v-col>
                                    <v-col cols="2">
                                        <p class="mx-2 my-0" :style="{ color: chain.Status.color}">
                                            <v-icon  small :style="{ color: chain.Status.color}">fas fa-{{ chain.Status.icon}}</v-icon>
                                            {{chain.Status.description_short}}
                                        </p>
                                    </v-col>
                                </v-row>
                            </v-card-title>
                            <v-card-subtitle>
                                Transaction added: {{  chain.Timestamp | moment("DD.MM.YYYY  h:mm:ss") }}
                            </v-card-subtitle>
                            <v-card-text  class="white text--primary">
                                <v-row>
                                    <v-col cols="9">
                                      <span v-if="chain.SerialNumber">  Serial Number: <strong>{{chain.SerialNumber}}</strong><br/> </span>
                                        <span v-if="chain.BatchOrLotNumber">  Batch or Lot Number: <strong>{{chain.BatchOrLotNumber}}</strong><br/> </span>
                                        <span> Shipment Date: <strong>{{chain.ShipmentDate}}</strong><br/> </span>
                                        <span> Sender Country: <strong>{{chain.SenderCountry}}</strong><br/></span>
                                    </v-col>
                                    <v-col cols="3" align="center">
                                        <v-btn color="primary"  :to="`/trace/transactions/${chain.ID}`">
                                            Go to transaction
                                        </v-btn>
                                    </v-col>
                                </v-row>

                            </v-card-text>

                        </v-card>
                    </v-timeline-item>
                    </v-timeline>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>


<script>
import ChainAPI from "../../api/trace/chain"
import LoadingState from "../../consts/LoadingState"
import {mapState} from "vuex"
export default {
	name: "ChainHistoryView",
	data() {
		return {
			data:null,
			transactionID:location.pathname?.split("/")?.reverse()?.[1],
		}
	},
	mounted() {
		if(this.transactionID){
			this.getChain()
		}
	},
	methods: {
		getChain(){
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			ChainAPI.getChain(this.transactionID)
				.then(data => {
					this.data=data
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		}
	},
	computed: {
		...mapState("loading", {
			loading: state => state.loading == LoadingState.LOADING
		})
	}
}
</script>